module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fExfW"))).then(() => module.bundle.root('f4eak'));